import { Select } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getSemesters } from "../../api/semesters.api";
import { getAppInstallStatsByDevice, getAppInstallStatsByStudent } from "../../api/statistics.api";
import Button from "../../components/Button";
import ErrorResponse from "../../components/ErrorResponse";
//import Header from "../../components/layout/Header";
import Loader from "../../components/Loader";
import SelectCampus from "../../components/SelectCampus";
import Device from "../../components/statistics/app-student/Device";
import Student from "../../components/statistics/app-student/Student";
import TabItem from "../../components/statistics/TabItem";
import useAxios from "../../hooks/useAxios";
import useNotification from "../../hooks/useNotification";
import config from "../../lib/config";
import { IGetSemesters, ISemester } from "../../models/semesters.model";
import { IAppInstallStatsParams, IGetAppInstallStatsByDevice, IGetAppInstallStatsByStudent } from "../../models/statistics.model";
import { RootState } from "../../store/rootReducer";
import TableEmpty from "../../components/common/TableEmpty";

enum Contents {
  Student,
  Device,
}

const StatisticsAppStudent = () => {
  const { t, i18n } = useTranslation();
  const { auth, currentCampus } = useSelector((state: RootState) => state.auth);
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const { infoNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetSemesters>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetAppInstallStatsByStudent>();
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios<IGetAppInstallStatsByDevice>();

  const [content, setContent] = useState(Contents.Student);
  const [campusCode, setCampusCode] = useState<string>("");
  const [semesterCode, setSemesterCode] = useState<number>();
  const [pageNo, setPageNo] = useState(1);
  const [isFirstRun, setIsFirstRun] = useState(true);
  const [field, setField] = useState('memberInfo');
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    execute(getSemesters());
  }, []);

  useEffect(() => {
    if (isFirstRun) {
      setIsFirstRun(false);
      return;
    }

    getAppInstallStats(1);
  }, [content]);

  useEffect(() => {
    if (isFirstRun) {
      return;
    }

    getAppInstallStats();
  }, [pageNo]);

  const getAppInstallStats = (_pageNo?: number) => {
    if (!semesterCode) {
      return infoNotification(t('statistics.appstudent.message1'));
    }
    if (_pageNo) {
      setPageNo(_pageNo);
    }

    const req: any = {
      semesterCode,
      campusCode: auth.hqYn === 'Y'
        ? campusCode
        : currentCampus,
      pageNo: _pageNo || pageNo,
      perPage: config.pageSize,
    }

    if (field && keyword) {
      req[field] = String(keyword);
    }

    switch (content) {
      case Contents.Student:
        execute2(getAppInstallStatsByStudent(req));
        break;
      case Contents.Device:
        execute3(getAppInstallStatsByDevice(req));
        break;
    }    
  }

  const renderContent = () => {
    switch (content) {
      case Contents.Student:
        return (
          <Student
            res={res2}
            pageNo={pageNo}
            setPageNo={setPageNo}
            semesterCode={semesterCode}
            campusCode={campusCode}
          />
        );
      case Contents.Device:
        return (
          <Device
            res={res3}
            pageNo={pageNo}
            setPageNo={setPageNo}
            semesterCode={semesterCode}
            campusCode={campusCode}
          />
        );
    }
  }

  return (
    <div>
      <div className="common-search">
        <div className="search-area">
          <ul className="search-bx">
            <li>
              <label>{t('common.menu.campus')}</label> {/* 캠퍼스 */}
              <div className="w-150p">
                {auth.hqYn === 'Y' ? (
                  <SelectCampus
                    className="w-100"
                    placeholder={t('class.class.placeholder1')}
                    value={campusCode}
                    onChange={(value: string) => setCampusCode(value)}
                    hasAll={true}
                  />
                ) : (
                  <SelectCampus />
                )}
              </div>
            </li>
            <li>
              <label>{t('class.class.placeholder4')}</label> {/* 학기 */}
              <Select
                className="w-120p"
                placeholder={t('statistics.regularTest.placeholder2')}
                value={semesterCode}
                onChange={value => setSemesterCode(value)}
              >
                {
                  res?.data?.map((item: ISemester) => {
                    return (
                      <Select.Option
                        key={item.semesterCode}
                        value={item.semesterCode}
                      >
                        {item.semesterName}
                      </Select.Option>
                    )
                  })
                }
              </Select>
            </li>
            <li>
              <label>{t('common.button.search')}</label>
              <Select
                className="w-110p"
                placeholder={t('student.student.placeholder6')}
                value={field}
                onChange={value => setField(value)}
              >
                <Select.Option value="memberInfo">{t('common.text.all')}</Select.Option>
                <Select.Option value="studentName">{t('student.student.placeholder2')}</Select.Option>
                <Select.Option value="studentWebId">{t('student.student.option31')}</Select.Option>
                <Select.Option value="memberCode">{t('student.student.option34')}</Select.Option>
              </Select>
              <input
                type="text"
                className="form-control w-150p mr-1"
                placeholder={t('student.student.placeholder7')}
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') getAppInstallStats(1);
                }}
              />
              <div className="comm-btn__area">
                <Button
                  className="btn-basic small black"
                  onClick={() => getAppInstallStats(1)}
                  text={t('common.button.search')}
                />
              </div>
            </li>
          </ul>
        </div>
      </div>	

      {(isLoading || isLoading2 || isLoading3) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />

      <div className="col-frame">
        {
          res2?.data
            ? (
              <>
                <div className="comm-tab__line">
                  <ul>
                    <TabItem
                      currentContent={content}
                      onSetContent={setContent}
                      tabContent={Contents.Student}
                      tabLabel={t('statistics.appstudent.Tab1')}
                    />
                    <TabItem
                      currentContent={content}
                      onSetContent={setContent}
                      tabContent={Contents.Device}
                      tabLabel={t('statistics.appstudent.Tab2')}
                    />
                  </ul>
                </div>
                <div>
                  {renderContent()}                  
                </div>
              </>
              )
            : (
              <TableEmpty text={t('statistics.appday.text1')} />
              )
        }
      </div>
    </div>
  );
}

export default StatisticsAppStudent;
